<template>
  <div class="search-wrapper">
    <d-input-group>
      <ss-autocomplete
        placeholder="Osoba wydająca"
        :options="users"
        :value="selectedUser" 
        @optionSelected="handleUserSelection"
      />
      <ExpenseSelect
        name="contract_status"
        id="select-status"
        placeholder="--Rodzaj operacji"
        :options="costTypes"
        v-model="filters.expenses_cost_type"
      />
      <ExpenseSelect
        name="contract_status"
        id="select-transfer-complete"
        :placeholder="transferStatusOptions.placeholder"
        :options="transferStatusOptions.options"
        v-model="filters.transfer_complete"
      />
      <ExpenseSelect
        name="contract_status"
        id="select-cash-refunded"
        :placeholder="cashRefundedOptions.placeholder"
        :options="cashRefundedOptions.options"
        v-model="filters.cash_refunded"
      />
      <d-input
        type="text"
        style="min-width: 300px;"
        name="search"
        placeholder="Numer konta, tytuł przelewu, odbiorca..."
        v-model="filters.search" 
      />
      <button
        class="button btn autocomplete-clear btn-primary"
        @click.prevent="filterList">
        Szukaj
      </button>
      <button
        class="button btn autocomplete-clear btn-secondary"
        @click.prevent="clearFilters">Wyczyść
      </button>
    </d-input-group>
  </div>
</template>

<script>
import SsAutocomplete from '@/components/common/SsAutocomplete'
import ExpenseSelect from '@/components/expense/list/molecules/ExpenseSelect.vue';

export default {
  props: {
    users: {
      type: Array,
      required: true
    },
    costTypes: {
      type: Array,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  components: { 
    SsAutocomplete,
    ExpenseSelect 
  },
  methods: {
    filterList(){
      this.$emit('filter', this.filters)
    },
    clearFilters(){
      this.$emit('clear')
    },
    handleUserSelection(userId){
      this.$emit('userSelected', userId)
    }
  },
  data() {
    return {
      transferStatusOptions: {
        placeholder: '--Realizacja płatności',
        options: [
          { id: 1, name: 'Zrealizowana' },
          { id: 0, name: 'Nie zrealizowana' }
        ]
      },
      cashRefundedOptions: {
        placeholder: '--Zwrot gotówki',
        options: [
          { id: 1, name: 'Wykonano zwrot' },
          { id: 0, name: 'Nie wykonano zwrotu' }
        ]
      }
    }
  },
  computed: {
    selectedUser(){
      const user = this.users.find( user => user.id === Number(this.filters.user_id))
      return user ? [ user.name, user.surname ].join(' ') : ''
    }
  }
}
</script>
